import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../../../assets/css/fullcalendar.min.css'
import 'react-big-calendar/lib/less/month.less'
import '../../../assets/css/react-big-calendar.css'
import 'react-big-calendar/lib/less/styles.less'
import FullCalendar from 'fullcalendar-reactwrapper';
import {convertUTCDateToLocalDate, isRegularLunchOrderType, getNotWorkingDays} from "../../../server/util";
import {get} from '../../../server/actions'
import $ from "jquery";
import moment from 'moment';
import {MONTH,currency_symbol} from "../../../server/constants";
let schoolId=0;
let monthYear='';
const MealTypes={
    breakfast:'BREAKFAST',
    meal:'MEAL',
    side:'SIDE',
    holiday:'HOLIDAY'
};
class ParentBreakfastComponent extends Component {
    constructor() {
        super()
        this.state = {
            orderedMenu: [],
            date: new Date(),
            showCalendar: false,
            pdfLink: '',
            noBreakfast:false
        }
        this.loadBreakfast=this.loadBreakfast.bind(this);
    }
    componentWillMount = () => {
         if (this.props.type === "breakfast") {
            const {grade} = this.context.router.route.location.state;
            schoolId=this.props.schoolId;
            monthYear=this.props.monthYear;
            this.loadBreakfast(this.props.schoolId,grade)
        }
    }
    loadBreakfast = (sid,grade) => {        
        get('/mealSummaryDetails?menuSummaryId=0&mealSchoolId='+sid+'&yearMonth='+monthYear+'&grade='+grade+'&itemType=Breakfast&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            if(Object.keys(data).length>0)
            {
                let meals=(((data||{}).availableMenu||{})[moment().format('YYYYMM')]||{}).menuItemsList||[];

                //let meals = data.menuItemsList;//eval('(' + data.jsonData + ')');
                meals.forEach(event => {
                    if (event.type === MealTypes.breakfast) {
                        let dt=moment(event.start,'YYYY-MM-DD').toDate();
                        event.start = dt.addHours(1);
                        event.title=event.name;
                    }else if(event.type===MealTypes.side){
                        let dt=moment(event.start,'YYYY-MM-DD').toDate();
                        event.start = dt.addHours(1);
                        event.title=event.name;
                    }
                    else{
                        let dt=moment(event.start,'YYYY-MM-DD').toDate();
                        event.start = dt.addHours(1);
                        event.title=event.name;
                    }
                });
                let d = new Date(this.props.monthYear.substr(0,4), parseInt(this.props.monthYear.substr(4,this.props.monthYear.length)-1) )
                this.setState({orderedMenu: meals, date: d, showCalendar: true, pdfLink: data.pdfUrl,noBreakfast:false});
            }
            else{
                this.setState({  showCalendar: true, noBreakfast: true});
            }
            
        }).catch(error => {
            console.log("Loading Menu Failed", error)
        })
    }
    eventStyles = (event, element, view) => {
        if (event.type === "MEAL" || event.type==='BREAKFAST') {
            return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                'white-space: pre-wrap;color: black;font-size: 13px;font-weight: bolder">'
                + event.title + "  " + currency_symbol(this.props.schoolId||0) + event.price + '</div>');
        }
        else if (event.type === "SIDE") {
            event.start = event.start + (1 * 60 * 60 * 1000);
            element.css('background-color', 'inherit');
            element.css('border', '0px');
            element.css('font-weight', 'bolder');
            element.css('white-space', 'pre-wrap');
            element.css('color', 'red');
            element.css('font-size', '12px');
            element.css(' margin-bottom', '-5px');
        }
    }

   

    render() {
        if (!this.state.showCalendar) {
            return (
                <div>
                    <h4>Loading ...</h4>
                </div>
            )
        }
        else {
            return (<div>{this.state.noBreakfast?<div>
                        <p className="text-center col-lg-12 col-md-12 col-xs-12 col-sm-12">No breakfast available for current month.</p>
                    </div>:
                <div>
                
                    <div className="row margin-top-10 mr-bt-5 manage-order-pdf-row">
                        <div className="col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-6"><h4
                            className="text-center color-3">{MONTH[this.state.date.getMonth()] + ' ' + this.state.date.getFullYear()}</h4>
                        </div>
                        <a className="col-md-3 col-sm-3 col-xs-6"
                           href={this.state.pdfLink} target="_blank" download>
                            <button type="button"
                                    className="pull-right btn-social btn-linkedin-filled btn-rounded ">
                                <i class="fa fa-file-pdf-o"></i> Download PDF
                            </button>
                        </a>
                    </div>

                    <div className="table-responsive mr-bt-10">
                    
                        <FullCalendar
                            id={'your-custom-ID'+schoolId}
                            header={false}
                            //weekends={false}
                            hiddenDays={getNotWorkingDays(this.props.schoolId||0)}
                            editable={false}
                            resizable={false}
                            eventOrder= 'type'
                            defaultDate={this.state.date}
                            navLinks={false} // can click day/week names to navigate views
                            eventLimit={false} // allow "more" link when too many events
                            events={this.state.orderedMenu}
                            eventRender={this.eventStyles}
                            height={700}

                            eventClick={this.state.canOrder ? this.selectEvent : ''}
                            displayEventTime={false}
                            fixedWeekCount={false}
                            // droppable: true, // this allows things to be dropped onto the calendar

                        />
                    
                   
                        
                    </div> 

                </div>}</div>
            )
        }

    }
}
ParentBreakfastComponent.contextTypes = {
    router: PropTypes.object.isRequired
}

export default ParentBreakfastComponent;


// WEBPACK FOOTER //
// ./src/components/Parent/OrderMeals/parentBreakfastComponent.jsx